var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3635 18.2959C23.7321 18.9123 23.3712 19.7994 23.4614 20.7465C23.5967 22.3702 25.0851 23.5579 26.7089 23.5579H29.5654V25.347C29.5654 28.4591 27.0246 31 23.9125 31H6.65307C3.54097 31 1.00017 28.4591 1.00017 25.347V15.229C1.00017 12.1169 3.54097 9.57605 6.65307 9.57605H23.9125C27.0246 9.57605 29.5654 12.1169 29.5654 15.229V17.3939H26.5284C25.6865 17.3939 24.9198 17.7246 24.3635 18.2959Z",
    stroke: "#510073",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.5822V9.71156C1 7.92248 2.09751 6.32877 3.76631 5.69733L15.7036 1.18704C17.5678 0.480423 19.5674 1.86362 19.5674 3.86319V9.57621",
    stroke: "#510073",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1577 18.9254V22.1396C31.1577 22.9977 30.5305 23.6998 29.7323 23.731H26.9386C25.3992 23.731 23.9881 22.4984 23.8599 20.8133C23.7743 19.8304 24.1164 18.9098 24.7151 18.2701C25.2424 17.6772 25.9694 17.334 26.7676 17.334H29.7323C30.5305 17.3652 31.1577 18.0673 31.1577 18.9254Z",
    stroke: "#510073",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39665 16.4201H18.3629",
    stroke: "#510073",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.2fc4fd213aa41bebb8251d025662c7d6.svg";
export { ForwardRef as ReactComponent };